import React from "react";
import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";

const Logo = ({ light = false }) => {
  return (
    <Link to="/" className="flex items-center gap-2.5 group">
      <span className="relative flex h-10 w-10 items-center justify-center rounded-xl brand-gradient shadow-lg shadow-blue-600/30 transition-transform duration-300 group-hover:scale-105">
        <TrendingUp className="h-5 w-5 text-white" strokeWidth={2.6} />
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-display text-lg font-800 font-bold tracking-tight ${
            light ? "text-white" : "text-slate-900"
          }`}
        >
          JELLIS
        </span>
        <span
          className={`text-[10px] font-semibold tracking-[0.32em] ${
            light ? "text-blue-200" : "text-blue-600"
          }`}
        >
          ENTERPRISE
        </span>
      </span>
    </Link>
  );
};

export default Logo;
